(function () {
  'use strict';

  angular
    .module('directives.breadcrumb', [])

    /* @ngInject */
    .directive('breadcrumb', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $('#navMenu, #navSecondary, #navAside').find('li.active').removeClass('active');

          var $items = element.find('.item'),
            i,
            len = $items.length;

          for (i = 0; i < len; i++) {
            var id = $($items[i]).data('id');
            $('#navMenu, #navSecondary, #navAside').find('li[data-id="' + id + '"]').addClass('active');
          }
        }
      };
    })

    /* @ngInject */
    .directive('breadcrumbAccount', ["$timeout", function ($timeout) {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $('#navMenu, #navSecondary, #navAside').find('li.active').removeClass('active');

          var $items = element.find('.item-3'),
            i,
            len = $items.length;

          for (i = 0; i < len; i++) {
            var menu = $($items[i]).data('menu');
            $timeout(addActive, 0, true, menu);
          }
        }
      };

      // Functions

      function addActive(menu) {
        $('#navAside').find('li[data-menu="' + menu + '"]').addClass('active');
      }

    }]);

})();
